'use strict';

var ActionTypes = require('../constants/ActionTypes'),
    AppDispatcher = require('../AppDispatcher'),
    NotificationActionCreators = require('../actions/NotificationActionCreators'),
    NotificationMessages = require('../constants/NotificationMessages'),
    UserStore = require('../stores/UserStore'),
    RouterStore = require('../stores/RouterStore'),
    ModalActionCreators = require('../actions/ModalActionCreators'),
    ModalTypes = require('../constants/ModalTypes'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    AlertTypes = require('../constants/AlertTypes');

var UserServerActionCreators = {
  handleUser(err, response, userId) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_USER_ERROR : ActionTypes.REQUEST_USER_SUCCESS,
      response: response,
      userId: userId
    });

    if (err) {
      console.error(err);

      var params = RouterStore.getRouterState().params;
      if (err.status === 404 && parseInt(params.userId, 10) === userId) {
        AlertActionCreators.showAlert(AlertTypes.NOT_FOUND);
      }
    }
  },

  handleToggleServiceAccountHidden(err, response, serviceType) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.TOGGLE_SERVICE_ACCOUNT_HIDDEN_ERROR : ActionTypes.TOGGLE_SERVICE_ACCOUNT_HIDDEN_SUCCESS,
      response: response,
      serviceType: serviceType
    });

    if (err) {
      console.error(err);
    }
  },

  handleDisconnectServiceAccount(err, response, serviceType) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.DISCONNECT_SERVICE_ACCOUNT_ERROR : ActionTypes.DISCONNECT_SERVICE_ACCOUNT_SUCCESS,
      response: response,
      serviceType: serviceType
    });

    if (err) {
      console.error(err);
    }
  },

  handleSaveSettings(err, response) {
    AppDispatcher.handleServerFormAction({
      type: err ? ActionTypes.SAVE_SETTINGS_ERROR : ActionTypes.SAVE_SETTINGS_SUCCESS,
      response: response,
      err: err
    });

    if (err) {
      console.error(err);
    } else {
      var me = UserStore.getMe();
      if (me.isUnconfirmedEmail) {
        var messageId = me.confirmedEmail ?
          NotificationMessages.USER_NEW_EMAIL_NEEDS_CONFIRMATION :
          NotificationMessages.USER_FIRST_EMAIL_NEEDS_CONFIRMATION;

        NotificationActionCreators.showNotification(messageId, {
          email: me.email
        });
      }
    }
  },

  handleRequestResetPassword(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_RESET_PASSWORD_ERROR : ActionTypes.REQUEST_RESET_PASSWORD_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    } else {
      NotificationActionCreators.showNotification(NotificationMessages.PASSWORD_RESET_CHECK_EMAIL);

      if (!UserStore.isAuthenticated()) {
        ModalActionCreators.showModal(ModalTypes.LOGIN);
      }
    }
  },

  handleResetPassword(err, response) {
    AppDispatcher.handleServerFormAction({
      type: err ? ActionTypes.RESET_PASSWORD_ERROR : ActionTypes.RESET_PASSWORD_SUCCESS,
      response: response,
      err: err
    });

    if (err) {
      console.error(err);
    } else {
      NotificationActionCreators.showNotification(NotificationMessages.PASSWORD_RESET_DONE);

      if (!UserStore.isAuthenticated()) {
        ModalActionCreators.showModal(ModalTypes.LOGIN);
      } else {
        ModalActionCreators.hideModal(ModalTypes.RESET_PASSWORD);
      }
    }
  },

  handleInvitationsPage(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_INVITATIONS_ERROR : ActionTypes.REQUEST_INVITATIONS_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleFeedback(err, response) {
    AppDispatcher.handleServerFormAction({
      type: err ? ActionTypes.FEEDBACK_ERROR : ActionTypes.FEEDBACK_SUCCESS,
      response: response,
      err: err
    });

    if (err) {
      console.error(err);
    } else {
      ModalActionCreators.hideModal(ModalTypes.FEEDBACK);
      NotificationActionCreators.showNotification(NotificationMessages.FEEDBACK_SENT);
    }
  },

  handleResendUnconfirmedEmail(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.RESEND_UNCONFIRMED_EMAIL_ERROR : ActionTypes.RESEND_UNCONFIRMED_EMAIL_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    } else {
      NotificationActionCreators.showNotification(NotificationMessages.USER_EMAIL_RESENT);
    }
  },

  handleCancelUnconfirmedEmail(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.CANCEL_UNCONFIRMED_EMAIL_ERROR : ActionTypes.CANCEL_UNCONFIRMED_EMAIL_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    } else {
      NotificationActionCreators.hideNotification(NotificationMessages.USER_FIRST_EMAIL_NEEDS_CONFIRMATION);
      NotificationActionCreators.hideNotification(NotificationMessages.USER_NEW_EMAIL_NEEDS_CONFIRMATION);
    }
  },

  handleResubscribeEmail(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.RESUBSCRIBE_EMAIL_ERROR : ActionTypes.RESUBSCRIBE_EMAIL_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    } else {
      NotificationActionCreators.hideNotification(NotificationMessages.EMAIL_UNSUBSCRIBE);
      NotificationActionCreators.showNotification(NotificationMessages.EMAIL_RESUBSCRIBED);
    }
  },

  handleSaveEmailNotificationSettings(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.SAVE_EMAIL_NOTIFICATION_SETTINGS_ERROR : ActionTypes.SAVE_EMAIL_NOTIFICATION_SETTINGS_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleFollowUser(err, response, userId) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.FOLLOW_USER_ERROR : ActionTypes.FOLLOW_USER_SUCCESS,
      response: response,
      userId: userId
    });

    if (err) {
      console.error(err);
    } else {
      NotificationActionCreators.showNotification(NotificationMessages.USER_FOLLOWED, {
        userId: userId
      });
    }
  },

  handleUnfollowUser(err, response, userId) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.UNFOLLOW_USER_ERROR : ActionTypes.UNFOLLOW_USER_SUCCESS,
      response: response,
      userId: userId
    });

    if (err) {
      console.error(err);
    }
  },

  handleUserSubscriberPage(err, response, userId) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_USER_SUBSCRIBERS_ERROR : ActionTypes.REQUEST_USER_SUBSCRIBERS_SUCCESS,
      userId: userId,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleUserSubscriptionPage(err, response, userId) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_USER_SUBSCRIPTIONS_ERROR : ActionTypes.REQUEST_USER_SUBSCRIPTIONS_SUCCESS,
      userId: userId,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleSearchPage(err, response, terms) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_USER_SEARCH_ERROR : ActionTypes.REQUEST_USER_SEARCH_SUCCESS,
      terms: terms,
      response: response
    });

    if (err) {
      console.error(err);
    }
  }
};

module.exports = UserServerActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/UserServerActionCreators.js
 **/